import Flex from 'typescript-styled-flex'
import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const TagRemoveWrapper = styled(Flex as any)<IWithSize>`
  align-items: center;
  padding-left: ${({ size }) => (size ? 12 * size : 12)}px;
  cursor: pointer;
  & > svg {
    stroke-width: 3;
  }
`

export default TagRemoveWrapper
